import { render } from "./Pinterest.vue?vue&type=template&id=6ca49dd4"
import script from "./Pinterest.vue?vue&type=script&lang=js"
export * from "./Pinterest.vue?vue&type=script&lang=js"
script.render = render

export default script